<template>
    <va-create-layout>
        <RefundEventShipmentFee-form
            :title="title"
            :item="item"
        ></RefundEventShipmentFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
